<template>
  <div class="result-type-wrapper">
    <div class="flex-center" :class="state">
      <Icon
        class="result-icon success"
        name="smiling-face"
        v-if="state == 'success'"
      ></Icon>
      <Icon
        class="result-icon storing"
        name="loading-one"
        v-if="state == 'storing'"
      ></Icon>
      <Icon
        class="result-icon fail"
        name="worried-face"
        v-if="state == 'fail'"
      ></Icon>
      <p class="result-title">{{ title }}</p>
    </div>
    <p class="opera-tips" v-html="tips"></p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['title', 'tips', 'state']
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialTopup/officialTopup.scss';
.result-type-wrapper {
  display: inline-block;
  margin-top: 102px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 40px;
}
.result-icon {
  flex-shrink: 0;
  margin-right: 15px;
  width: 60px;
  height: 60px;
}
.success {
  color:  #457eff;
}
.fail {
  color: #f56a57;
}
.storing {
  color: #333333;
}
.result-title {
  text-align: center;
  font-size: 38px;
  font-weight: bold;
}
.opera-tips {
  margin: 20px auto;
  line-height: 32px;
  text-align: center;
  font-size: 22px;
  color: #333333;
}
</style>
